import { StyleObject } from 'styletron-standard';

export const HIDE_SCROLLBAR: StyleObject = {
  scrollbarWidth: 'none',

  '::-webkit-scrollbar': {
    display: 'none',
  },
};
